import React, { FunctionComponent } from 'react';
import {
  CardListItem,
  CardListItemProps
} from 'record-it-components/cardList/CardListItem/CardListItem';
import { CardListItemIconButton } from 'record-it-components/cardList/CardListItemIconButton/CardListItemIconButton';
import { CardListItemTitle } from 'record-it-components/cardList/CardListItemTitle/CardListItemTitle';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { classes } from 'record-it-components/utils/utils';
import { TimeTrackingActivity } from '../../../classes/entities/TimeTrackingActivity/timeTrackingActivityTypes';
import { iconConfigurations } from '../../../classes/icon/iconConfigurations';
import styles from './TimeTrackingActivityToSelectListItem.module.css';

export type TimeTrackingActivityToSelectListItemProps =
  PropsWithoutChildren<CardListItemProps> & {
    timeTrackingActivity: TimeTrackingActivity;
    onActivitySelected: (activity: TimeTrackingActivity) => void;
  };

export const TimeTrackingActivityToSelectListItem: FunctionComponent<TimeTrackingActivityToSelectListItemProps> =
  React.memo((props) => {
    const {
      timeTrackingActivity,
      onActivitySelected,
      onClick,
      className,
      ...remainingProps
    } = prepareProps({ props, ignoreChildren: true });

    const handleClick: CardListItemProps['onClick'] = useEventCallback(
      (event) => {
        onClick?.(event);
        onActivitySelected(timeTrackingActivity);
      }
    );

    return (
      <CardListItem
        {...remainingProps}
        className={classes(className, styles.card)}
        onClick={handleClick}
      >
        <CardListItemTitle data-testid="TimeTrackingActivityToSelectListItem.Name">
          {timeTrackingActivity.name}
        </CardListItemTitle>
        {timeTrackingActivity.parentActivityId == null ? (
          <CardListItemIconButton
            {...iconConfigurations.prefixed.listItem.enterListItem}
            data-testid="TimeTrackingActivityToSelectListItem.Icon"
          ></CardListItemIconButton>
        ) : null}
      </CardListItem>
    );
  });
